<template>
  <div class="home-page"> 
    <div class="home-page--head" v-if="$siteConfig.brand ==='BookDirect'">
      <div class="home-page-logo">
        <span class="fw-bold"> BOOK<span class="color-blue">DIRECT</span><span class="color-light-grey-border">.COM</span></span>
      </div>
      <h1 class="home-page--title">{{$t('Search, compare and book')}}
        <span v-if="searchTab === 'hotels'">{{$t('hotels')}}</span>
        <span v-if="searchTab === 'activities'">{{$t('experiences')}}</span>
      </h1>
    </div>
    <div v-else-if="$siteConfig.brand === 'Solaire'" class="solaire-hero">
      <div class="solaire-hero__overlay">
        <span class="solaire-hero__tagline" v-html="$siteConfig.tagline"></span>
      </div>
    </div>
    <div v-else class="home-page-logo" >
      <span class="fw-bold" v-html="$siteConfig.tagline"></span>
    </div>
    <div>
      <div class="search-tabs" v-if="$siteConfig.brand !== 'Solaire'">
        <div class="search-tabs-container">
          <div class="search-tabs--list">
            <div
                :class="['search-tabs--item hotels', {active: searchTab === 'hotels'}]"
                @click="toggleSearchTab('hotels')"
            >
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_323_7186)">
                  <path d="M0.583496 12.25H1.86683M1.86683 12.25H7.00016M1.86683 12.25V3.85C1.86683 3.115 1.86683 2.7475 2.00671 2.46663C2.12991 2.21922 2.32562 2.01906 2.56753 1.89306C2.84216 1.75 3.2015 1.75 3.92016 1.75H4.94683C5.6655 1.75 6.02483 1.75 6.29946 1.89306C6.54093 2.01889 6.73724 2.21967 6.86028 2.46663C7.00016 2.74684 7.00016 3.11434 7.00016 3.84803V5.84959M7.00016 12.25H12.1335M7.00016 12.25V5.84959M7.00016 5.84959L7.2318 5.63566C7.7169 5.19006 7.95946 4.96759 8.23409 4.88294C8.47555 4.80853 8.73311 4.80853 8.97457 4.88294C9.2492 4.96759 9.49176 5.19006 9.97686 5.63566L11.4527 6.99212C11.7036 7.22247 11.8287 7.33797 11.9185 7.47578C11.9982 7.59827 12.0572 7.73359 12.0931 7.87609C12.1335 8.03688 12.1335 8.20947 12.1335 8.554V12.25M12.1335 12.25H13.4168" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </g>
                <defs>
                  <clipPath id="clip0_323_7186">
                    <rect width="14" height="14" fill="white"/>
                  </clipPath>
                </defs>
              </svg>

              {{t('Hotels')}}
            </div>
            <div
                :class="['search-tabs--item', {active: searchTab === 'activities'}]"
                @click="toggleSearchTab('activities')"
            >
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <mask id="path-1-inside-1_1284_616" fill="white">
                  <path d="M9.33333 0H9.2575C8.99644 0.00248022 8.74359 0.0915911 8.53865 0.253341C8.33372 0.415091 8.18831 0.640321 8.12525 0.893667C8.05771 1.14032 7.91101 1.35795 7.7077 1.51308C7.50438 1.66821 7.25573 1.75224 7 1.75224C6.74427 1.75224 6.49562 1.66821 6.2923 1.51308C6.08899 1.35795 5.94229 1.14032 5.87475 0.893667C5.81169 0.640321 5.66628 0.415091 5.46134 0.253341C5.25641 0.0915911 5.00356 0.00248022 4.7425 0L4.66667 0C3.8934 0.00092625 3.15208 0.308514 2.60529 0.855295C2.05851 1.40208 1.75093 2.1434 1.75 2.91667V12.25C1.75 12.7141 1.93437 13.1592 2.26256 13.4874C2.59075 13.8156 3.03587 14 3.5 14H4.7425C5.00356 13.9975 5.25641 13.9084 5.46134 13.7467C5.66628 13.5849 5.81169 13.3597 5.87475 13.1063C5.94229 12.8597 6.08899 12.642 6.2923 12.4869C6.49562 12.3318 6.74427 12.2478 7 12.2478C7.25573 12.2478 7.50438 12.3318 7.7077 12.4869C7.91101 12.642 8.05771 12.8597 8.12525 13.1063C8.18831 13.3597 8.33372 13.5849 8.53865 13.7467C8.74359 13.9084 8.99644 13.9975 9.2575 14H10.5C10.9641 14 11.4092 13.8156 11.7374 13.4874C12.0656 13.1592 12.25 12.7141 12.25 12.25V2.91667C12.2491 2.1434 11.9415 1.40208 11.3947 0.855295C10.8479 0.308514 10.1066 0.00092625 9.33333 0ZM10.5 12.8333L9.24992 12.7966C9.11291 12.3016 8.8164 11.8656 8.40637 11.5563C7.99634 11.247 7.49571 11.0816 6.98211 11.0858C6.46851 11.0899 5.97064 11.2635 5.56571 11.5794C5.16078 11.8954 4.87142 12.3362 4.7425 12.8333H3.5C3.34529 12.8333 3.19692 12.7719 3.08752 12.6625C2.97812 12.5531 2.91667 12.4047 2.91667 12.25V9.91667H4.08333C4.23804 9.91667 4.38642 9.85521 4.49581 9.74581C4.60521 9.63642 4.66667 9.48804 4.66667 9.33333C4.66667 9.17862 4.60521 9.03025 4.49581 8.92085C4.38642 8.81146 4.23804 8.75 4.08333 8.75H2.91667V2.91667C2.91667 2.45254 3.10104 2.00742 3.42923 1.67923C3.75742 1.35104 4.20254 1.16667 4.66667 1.16667L4.75008 1.20342C4.88671 1.69542 5.18058 2.12919 5.58683 2.43854C5.99307 2.74788 6.48938 2.9158 7 2.91667C7.51751 2.91226 8.01941 2.73893 8.42934 2.42303C8.83927 2.10713 9.13478 1.66597 9.27092 1.16667H9.33333C9.79746 1.16667 10.2426 1.35104 10.5708 1.67923C10.899 2.00742 11.0833 2.45254 11.0833 2.91667V8.75H9.91667C9.76196 8.75 9.61358 8.81146 9.50419 8.92085C9.39479 9.03025 9.33333 9.17862 9.33333 9.33333C9.33333 9.48804 9.39479 9.63642 9.50419 9.74581C9.61358 9.85521 9.76196 9.91667 9.91667 9.91667H11.0833V12.25C11.0833 12.4047 11.0219 12.5531 10.9125 12.6625C10.8031 12.7719 10.6547 12.8333 10.5 12.8333Z"/>
                </mask>
                <path d="M9.33333 0L9.33513 -1.5H9.33333V0ZM9.2575 0V-1.5H9.25037L9.24325 -1.49993L9.2575 0ZM8.12525 0.893667L9.572 1.28979L9.57661 1.27293L9.58084 1.25598L8.12525 0.893667ZM7 1.75224V0.252237V1.75224ZM5.87475 0.893667L4.41916 1.25598L4.42338 1.27293L4.428 1.28979L5.87475 0.893667ZM4.7425 0L4.75675 -1.49993L4.74963 -1.5H4.7425V0ZM4.66667 0V-1.5L4.66487 -1.5L4.66667 0ZM1.75 2.91667L0.25 2.91487V2.91667H1.75ZM1.75 12.25H0.25H1.75ZM3.5 14V15.5V14ZM4.7425 14V15.5H4.74963L4.75675 15.4999L4.7425 14ZM5.87475 13.1063L4.428 12.7102L4.42338 12.7271L4.41916 12.744L5.87475 13.1063ZM8.12525 13.1063L9.58084 12.744L9.57661 12.7271L9.572 12.7102L8.12525 13.1063ZM9.2575 14L9.24325 15.4999L9.25037 15.5H9.2575V14ZM10.5 14V15.5V14ZM12.25 12.25H13.75H12.25ZM12.25 2.91667H13.75L13.75 2.91487L12.25 2.91667ZM10.5 12.8333L10.4559 14.3327L10.478 14.3333H10.5V12.8333ZM9.24992 12.7966L7.80427 13.1967L8.09952 14.2634L9.20584 14.2959L9.24992 12.7966ZM4.7425 12.8333V14.3333H5.90315L6.19448 13.2098L4.7425 12.8333ZM2.91667 9.91667V8.41667H1.41667V9.91667H2.91667ZM2.91667 8.75H1.41667V10.25H2.91667V8.75ZM4.66667 1.16667L5.27142 -0.206022L4.98244 -0.333333H4.66667V1.16667ZM4.75008 1.20342L6.19539 0.802047L6.00522 0.11726L5.35484 -0.169272L4.75008 1.20342ZM7 2.91667L6.99746 4.41666L7.00511 4.41668L7.01276 4.41661L7 2.91667ZM9.27092 1.16667V-0.333333H8.12513L7.82374 0.7721L9.27092 1.16667ZM11.0833 2.91667H12.5833H11.0833ZM11.0833 8.75V10.25H12.5833V8.75H11.0833ZM11.0833 9.91667H12.5833V8.41667H11.0833V9.91667ZM9.33333 0V-1.5H9.2575V0V1.5H9.33333V0ZM9.2575 0L9.24325 -1.49993C8.64985 -1.49429 8.07513 -1.29175 7.60933 -0.924092L8.53865 0.253341L9.46798 1.43077C9.41204 1.47493 9.34302 1.49926 9.27175 1.49993L9.2575 0ZM8.53865 0.253341L7.60933 -0.924092C7.14352 -0.556437 6.813 -0.0444938 6.66966 0.531358L8.12525 0.893667L9.58084 1.25598C9.56362 1.32514 9.52393 1.38662 9.46798 1.43077L8.53865 0.253341ZM8.12525 0.893667L6.6785 0.497542C6.6978 0.42707 6.73971 0.364889 6.7978 0.320566L7.7077 1.51308L8.61759 2.7056C9.0823 2.35102 9.41763 1.85357 9.572 1.28979L8.12525 0.893667ZM7.7077 1.51308L6.7978 0.320566C6.85589 0.276244 6.92693 0.252237 7 0.252237V1.75224V3.25224C7.58453 3.25224 8.15288 3.06017 8.61759 2.7056L7.7077 1.51308ZM7 1.75224V0.252237C7.07307 0.252237 7.14411 0.276244 7.2022 0.320566L6.2923 1.51308L5.38241 2.7056C5.84712 3.06017 6.41546 3.25224 7 3.25224V1.75224ZM6.2923 1.51308L7.2022 0.320566C7.26029 0.364889 7.3022 0.42707 7.3215 0.497542L5.87475 0.893667L4.428 1.28979C4.58237 1.85357 4.9177 2.35102 5.38241 2.7056L6.2923 1.51308ZM5.87475 0.893667L7.33034 0.531358C7.187 -0.0444938 6.85648 -0.556437 6.39067 -0.924092L5.46134 0.253341L4.53202 1.43077C4.47607 1.38662 4.43638 1.32514 4.41916 1.25598L5.87475 0.893667ZM5.46134 0.253341L6.39067 -0.924092C5.92486 -1.29175 5.35014 -1.49429 4.75675 -1.49993L4.7425 0L4.72825 1.49993C4.65698 1.49926 4.58796 1.47493 4.53202 1.43077L5.46134 0.253341ZM4.7425 0V-1.5H4.66667V0V1.5H4.7425V0ZM4.66667 0L4.66487 -1.5C3.4944 -1.4986 2.37228 -1.03301 1.54463 -0.205365L2.60529 0.855295L3.66596 1.91596C3.93187 1.65004 4.2924 1.50045 4.66846 1.5L4.66667 0ZM2.60529 0.855295L1.54463 -0.205365C0.71699 0.62228 0.251403 1.7444 0.250001 2.91487L1.75 2.91667L3.25 2.91846C3.25045 2.5424 3.40004 2.18187 3.66596 1.91596L2.60529 0.855295ZM1.75 2.91667H0.25V12.25H1.75H3.25V2.91667H1.75ZM1.75 12.25H0.25C0.25 13.112 0.59241 13.9386 1.2019 14.5481L2.26256 13.4874L3.32322 12.4268C3.27634 12.3799 3.25 12.3163 3.25 12.25H1.75ZM2.26256 13.4874L1.2019 14.5481C1.8114 15.1576 2.63805 15.5 3.5 15.5L3.5 14V12.5C3.4337 12.5 3.37011 12.4737 3.32322 12.4268L2.26256 13.4874ZM3.5 14V15.5H4.7425V14V12.5H3.5V14ZM4.7425 14L4.75675 15.4999C5.35015 15.4943 5.92486 15.2917 6.39067 14.9241L5.46134 13.7467L4.53202 12.5692C4.58796 12.5251 4.65698 12.5007 4.72825 12.5001L4.7425 14ZM5.46134 13.7467L6.39067 14.9241C6.85648 14.5564 7.187 14.0445 7.33034 13.4686L5.87475 13.1063L4.41916 12.744C4.43638 12.6749 4.47607 12.6134 4.53202 12.5692L5.46134 13.7467ZM5.87475 13.1063L7.3215 13.5025C7.3022 13.5729 7.26029 13.6351 7.2022 13.6794L6.2923 12.4869L5.38241 11.2944C4.9177 11.649 4.58237 12.1464 4.428 12.7102L5.87475 13.1063ZM6.2923 12.4869L7.2022 13.6794C7.14411 13.7238 7.07307 13.7478 7 13.7478V12.2478V10.7478C6.41547 10.7478 5.84712 10.9398 5.38241 11.2944L6.2923 12.4869ZM7 12.2478V13.7478C6.92693 13.7478 6.85589 13.7238 6.7978 13.6794L7.7077 12.4869L8.61759 11.2944C8.15288 10.9398 7.58453 10.7478 7 10.7478V12.2478ZM7.7077 12.4869L6.7978 13.6794C6.73971 13.6351 6.69779 13.5729 6.6785 13.5025L8.12525 13.1063L9.572 12.7102C9.41763 12.1464 9.0823 11.649 8.61759 11.2944L7.7077 12.4869ZM8.12525 13.1063L6.66966 13.4686C6.813 14.0445 7.14352 14.5564 7.60933 14.9241L8.53865 13.7467L9.46798 12.5692C9.52393 12.6134 9.56362 12.6749 9.58084 12.744L8.12525 13.1063ZM8.53865 13.7467L7.60933 14.9241C8.07513 15.2917 8.64985 15.4943 9.24325 15.4999L9.2575 14L9.27175 12.5001C9.34302 12.5007 9.41204 12.5251 9.46798 12.5692L8.53865 13.7467ZM9.2575 14V15.5H10.5V14V12.5H9.2575V14ZM10.5 14V15.5C11.362 15.5 12.1886 15.1576 12.7981 14.5481L11.7374 13.4874L10.6768 12.4268C10.6299 12.4737 10.5663 12.5 10.5 12.5V14ZM11.7374 13.4874L12.7981 14.5481C13.4076 13.9386 13.75 13.112 13.75 12.25H12.25H10.75C10.75 12.3163 10.7237 12.3799 10.6768 12.4268L11.7374 13.4874ZM12.25 12.25H13.75V2.91667H12.25H10.75V12.25H12.25ZM12.25 2.91667L13.75 2.91487C13.7486 1.7444 13.283 0.62228 12.4554 -0.205365L11.3947 0.855295L10.334 1.91596C10.6 2.18187 10.7495 2.5424 10.75 2.91846L12.25 2.91667ZM11.3947 0.855295L12.4554 -0.205365C11.6277 -1.03301 10.5056 -1.4986 9.33513 -1.5L9.33333 0L9.33154 1.5C9.7076 1.50045 10.0681 1.65004 10.334 1.91596L11.3947 0.855295ZM10.5 12.8333L10.5441 11.334L9.29399 11.2972L9.24992 12.7966L9.20584 14.2959L10.4559 14.3327L10.5 12.8333ZM9.24992 12.7966L10.6956 12.3965C10.4705 11.5832 9.98335 10.867 9.30974 10.3588L8.40637 11.5563L7.503 12.7538C7.64944 12.8642 7.75534 13.0199 7.80427 13.1967L9.24992 12.7966ZM8.40637 11.5563L9.30974 10.3588C8.63612 9.85064 7.81365 9.57893 6.96988 9.58581L6.98211 11.0858L6.99434 12.5857C7.17777 12.5842 7.35656 12.6433 7.503 12.7538L8.40637 11.5563ZM6.98211 11.0858L6.96988 9.58581C6.12611 9.59269 5.30818 9.87778 4.64294 10.3969L5.56571 11.5794L6.48848 12.762C6.6331 12.6492 6.81091 12.5872 6.99434 12.5857L6.98211 11.0858ZM5.56571 11.5794L4.64294 10.3969C3.9777 10.916 3.50232 11.64 3.29052 12.4568L4.7425 12.8333L6.19448 13.2098C6.24052 13.0323 6.34386 12.8749 6.48848 12.762L5.56571 11.5794ZM4.7425 12.8333V11.3333H3.5V12.8333V14.3333H4.7425V12.8333ZM3.5 12.8333V11.3333C3.74311 11.3333 3.97627 11.4299 4.14818 11.6018L3.08752 12.6625L2.02686 13.7231C2.41756 14.1138 2.94747 14.3333 3.5 14.3333V12.8333ZM3.08752 12.6625L4.14818 11.6018C4.32009 11.7737 4.41667 12.0069 4.41667 12.25H2.91667H1.41667C1.41667 12.8025 1.63616 13.3324 2.02686 13.7231L3.08752 12.6625ZM2.91667 12.25H4.41667V9.91667H2.91667H1.41667V12.25H2.91667ZM2.91667 9.91667V11.4167H4.08333V9.91667V8.41667H2.91667V9.91667ZM4.08333 9.91667V11.4167C4.63586 11.4167 5.16577 11.1972 5.55647 10.8065L4.49581 9.74581L3.43515 8.68515C3.60706 8.51324 3.84022 8.41667 4.08333 8.41667V9.91667ZM4.49581 9.74581L5.55647 10.8065C5.94717 10.4158 6.16667 9.88587 6.16667 9.33333H4.66667H3.16667C3.16667 9.09022 3.26324 8.85706 3.43515 8.68515L4.49581 9.74581ZM4.66667 9.33333H6.16667C6.16667 8.7808 5.94717 8.25089 5.55647 7.86019L4.49581 8.92085L3.43515 9.98151C3.26324 9.80961 3.16667 9.57645 3.16667 9.33333H4.66667ZM4.49581 8.92085L5.55647 7.86019C5.16577 7.46949 4.63587 7.25 4.08333 7.25V8.75V10.25C3.84022 10.25 3.60706 10.1534 3.43515 9.98151L4.49581 8.92085ZM4.08333 8.75V7.25H2.91667V8.75V10.25H4.08333V8.75ZM2.91667 8.75H4.41667V2.91667H2.91667H1.41667V8.75H2.91667ZM2.91667 2.91667H4.41667C4.41667 2.85036 4.44301 2.78677 4.48989 2.73989L3.42923 1.67923L2.36857 0.61857C1.75908 1.22806 1.41667 2.05471 1.41667 2.91667H2.91667ZM3.42923 1.67923L4.48989 2.73989C4.53677 2.69301 4.60036 2.66667 4.66667 2.66667V1.16667V-0.333333C3.80471 -0.333333 2.97806 0.00907653 2.36857 0.61857L3.42923 1.67923ZM4.66667 1.16667L4.06191 2.53936L4.14533 2.57611L4.75008 1.20342L5.35484 -0.169272L5.27142 -0.206022L4.66667 1.16667ZM4.75008 1.20342L3.30478 1.60479C3.52903 2.41228 4.01134 3.12422 4.67809 3.63193L5.58683 2.43854L6.49557 1.24514C6.34983 1.13417 6.2444 0.978549 6.19539 0.802047L4.75008 1.20342ZM5.58683 2.43854L4.67809 3.63193C5.34484 4.13965 6.15941 4.41525 6.99746 4.41666L7 2.91667L7.00254 1.41667C6.81935 1.41636 6.6413 1.35612 6.49557 1.24514L5.58683 2.43854ZM7 2.91667L7.01276 4.41661C7.85715 4.40943 8.67608 4.1266 9.34494 3.61117L8.42934 2.42303L7.51374 1.23489C7.36274 1.35125 7.17786 1.4151 6.98724 1.41672L7 2.91667ZM8.42934 2.42303L9.34494 3.61117C10.0138 3.09574 10.496 2.37591 10.7181 1.56123L9.27092 1.16667L7.82374 0.7721C7.7736 0.956021 7.66474 1.11853 7.51374 1.23489L8.42934 2.42303ZM9.27092 1.16667V2.66667H9.33333V1.16667V-0.333333H9.27092V1.16667ZM9.33333 1.16667V2.66667C9.39964 2.66667 9.46323 2.69301 9.51011 2.73989L10.5708 1.67923L11.6314 0.61857C11.0219 0.00907635 10.1953 -0.333333 9.33333 -0.333333V1.16667ZM10.5708 1.67923L9.51011 2.73989C9.55699 2.78677 9.58333 2.85036 9.58333 2.91667H11.0833H12.5833C12.5833 2.05471 12.2409 1.22806 11.6314 0.61857L10.5708 1.67923ZM11.0833 2.91667H9.58333V8.75H11.0833H12.5833V2.91667H11.0833ZM11.0833 8.75V7.25H9.91667V8.75V10.25H11.0833V8.75ZM9.91667 8.75V7.25C9.36413 7.25 8.83423 7.46949 8.44353 7.86019L9.50419 8.92085L10.5648 9.98151C10.3929 10.1534 10.1598 10.25 9.91667 10.25V8.75ZM9.50419 8.92085L8.44353 7.86019C8.05282 8.2509 7.83333 8.7808 7.83333 9.33333H9.33333H10.8333C10.8333 9.57645 10.7368 9.8096 10.5648 9.98151L9.50419 8.92085ZM9.33333 9.33333H7.83333C7.83333 9.88586 8.05282 10.4158 8.44353 10.8065L9.50419 9.74581L10.5648 8.68515C10.7368 8.85706 10.8333 9.09022 10.8333 9.33333H9.33333ZM9.50419 9.74581L8.44353 10.8065C8.83423 11.1972 9.36414 11.4167 9.91667 11.4167V9.91667V8.41667C10.1598 8.41667 10.3929 8.51324 10.5648 8.68515L9.50419 9.74581ZM9.91667 9.91667V11.4167H11.0833V9.91667V8.41667H9.91667V9.91667ZM11.0833 9.91667H9.58333V12.25H11.0833H12.5833V9.91667H11.0833ZM11.0833 12.25H9.58333C9.58333 12.0069 9.67991 11.7737 9.85182 11.6018L10.9125 12.6625L11.9731 13.7231C12.3638 13.3324 12.5833 12.8025 12.5833 12.25H11.0833ZM10.9125 12.6625L9.85182 11.6018C10.0237 11.4299 10.2569 11.3333 10.5 11.3333V12.8333V14.3333C11.0525 14.3333 11.5824 14.1138 11.9731 13.7231L10.9125 12.6625Z" fill="currentColor" mask="url(#path-1-inside-1_1284_616)"/>
                <path d="M7.58301 8.75H6.41634C6.26163 8.75 6.11326 8.81146 6.00386 8.92085C5.89447 9.03025 5.83301 9.17862 5.83301 9.33333C5.83301 9.48804 5.89447 9.63642 6.00386 9.74581C6.11326 9.85521 6.26163 9.91667 6.41634 9.91667H7.58301C7.73772 9.91667 7.88609 9.85521 7.99549 9.74581C8.10488 9.63642 8.16634 9.48804 8.16634 9.33333C8.16634 9.17862 8.10488 9.03025 7.99549 8.92085C7.88609 8.81146 7.73772 8.75 7.58301 8.75Z" fill="currentColor"/>
              </svg>

              {{t('Experiences')}}
            </div>
          </div>
        </div>
      </div>
      <template v-if="searchTab === 'hotels'">
        <SearchPanel />
      </template>
      <template v-if="searchTab === 'activities'">
        <ActivitiesSearchPanel />
      </template>
      <div class="attractions-container" v-if="$siteConfig.brand !== 'Solaire'">
        <TopPicksForTravelers v-show="searchTab === 'activities'" key="activities"/>
        <FeaturedProperties v-show="searchTab === 'hotels'" key="featuredProperties"/>
      </div>
      <div class="bd-popular-destinations">
        <PopularDestinations />
      </div>
      <article class="home-page-article">
        <h2>{{$t('Find and Book Your Perfect Stay')}}</h2>
        <p>{{$t("Welcome to BookDirect, the smarter way to plan your next trip. Our platform connects you directly with thousands of trusted hotels worldwide, giving you access to the best rates and exclusive offers — no middlemen, no hidden fees. Whether you're looking for a luxury resort, a cozy boutique hotel, or a family-friendly stay, we make it easy to book direct hotel options that match your needs. Start your journey with confidence and enjoy a seamless booking experience, every time.")}}</p>
      </article>
      <!-- Live chat button disabled for now — use the /support contact form. Remove v-if="false" to re-enable. -->
      <div class="live-chat-section" v-if="false">
        <button class="btn btn-primary open-live-chat" @click="openLiveChat">
          <img src="/icons/chat.svg" alt="" role="presentation" aria-hidden="true">
          {{t('Open LiveChat')}}
        </button>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import FeaturedProperties from "~/components/HomePage/FeaturedProperties.vue";
import PopularDestinations from "~/components/HomePage/PopularDestinations.vue";
const ActivitiesSearchPanel = defineAsyncComponent(() => import("~/components/SearchPanel/ActivitiesSearchPanel.vue"));

const { t } = useI18n()
const { $siteConfig } = useNuxtApp()
const liveChat = useLiveChat()

const openLiveChat = () => {
  liveChat.showLiveChat()
}

const searchTab = ref<String>('hotels')

const toggleSearchTab = (tab:string) => {
  searchTab.value = tab
  localStorage.setItem('searchTab', tab)
}

onMounted(() => {
  // Solaire sells hotels only — ignore any persisted tab and stay on hotels.
  if ($siteConfig.value.brand === 'Solaire') return
  const tab = localStorage.getItem('searchTab')
  if (tab) {
    searchTab.value = tab
  }
})
</script>

<style lang="scss">
.home-page {
  width: 100%;
  padding: 18px 0;

  &--head {
    max-width: 1120px;
    margin: 0 auto;
    padding: 80px 0;

    @media (max-width: 1024px) {
      padding: 0 16px 48px;
    }

    @media (max-width: 768px) {
      padding: 6px 16px 24px;
    }
  }

  &--title {
    font-weight: 600;
    font-size: 34px;
    line-height: 44px;
    letter-spacing: 0;
    vertical-align: middle;

    @media (max-width: 768px) {
      font-size: 20px;
      line-height: 24px;
    }
  }


  &-logo {
    font-size: 64px;
    line-height: 78px;
    padding: 0;
    margin-bottom: 12px;

    @media (max-width: 1024px) {
      font-size: 48px;
      line-height: 60px;
    }

    @media (max-width: 768px) {
      display: none;
      font-size: 32px;
      line-height: 42px;
      margin-bottom: 24px;
    }
  }

  .search-tabs {
    &-container {
      width: 100%;
      max-width: var(--content-max-width);
      margin: 0 auto;
      padding-top: 20px;

      @media (max-width: 1024px) {
        padding: 20px 16px 0 16px;
      }
    }
    &--list {
      display: flex;
      border-bottom: 2px solid var(--grey-border);
    }

    &--item {
      font-size: 16px;
      line-height: 20px;
      font-weight: 600;
      color: var(--black);
      position: relative;
      padding: 0 14px 7px;
      cursor: pointer;
      display: flex;
      gap: 8px;
      align-items: center;

      :root[data-theme="dark"] & {
        background: var(--light-grey);
        color: var(--dark-grey-secondary);
      }

      &.active {
        color: var(--blue);

        :root[data-theme="dark"] & {
          color: var(--blue);
        }

        &::after {
          content: "";
          display: block;
          position: absolute;
          bottom: -2px;
          left: 0;
          right: 0;
          height: 2px;
          background-color: var(--blue);
        }
      }
    }
  }

  .attractions-container {
    max-width: var(--content-max-width);
    margin: 0 auto;
    padding: 40px 0;

    @media (max-width: 1024px) {
      padding: 40px 16px;
    }
  }

  .home-page-article {
    max-width: 1120px;
    margin: 0 auto;
    padding: 24px 0 68px 0;

    h2 {
      font-size: 24px;
      font-weight: 600;
      line-height: 36px;
      margin-bottom: 20px;
    }

    p {
      font-size: 16px;
    }

    @media (max-width: 1024px) {
      padding: 24px 15px;
    }
  }
}

.solaire-hero {
  position: relative;
  max-width: var(--content-max-width);
  margin: 0 auto;
  border-radius: 16px;
  overflow: hidden;
  min-height: 380px;
  display: flex;
  align-items: flex-end;
  background: url("/images/solaire-hero.png") center / cover no-repeat;

  @media (max-width: 1024px) {
    margin: 0 16px;
    min-height: 280px;
  }

  &__overlay {
    width: 100%;
    padding: 40px;
    background: linear-gradient(to top, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0));

    @media (max-width: 768px) {
      padding: 24px 20px;
    }
  }

  &__tagline {
    display: block;
    color: #fff;
    font-size: 40px;
    line-height: 1.2;
    font-weight: 600;
    // Keep the white tagline legible over light areas of the hero photo.
    text-shadow: 0 2px 6px rgba(0, 0, 0, 0.45), 0 0 2px rgba(0, 0, 0, 0.35);

    @media (max-width: 768px) {
      font-size: 24px;
    }
  }
}

.bd-popular-destinations {
  .popular-destinations {
    &__title {
      font-size: 24px;
    }

    &__info p {
      font-size: 16px;
    }
  }
}

.live-chat-section {
  display: flex;
  justify-content: center;
  padding: 0 0 40px 0;

  @media (max-width: 1024px) {
    padding: 0 16px 40px;
  }
}

.btn.open-live-chat {
  display: flex;
  align-items: center;
  gap: 8px;
  border-radius: 6px;
  background: var(--blue);

  &:hover {
    background: var(--blue);
  }
}
</style>
